import { render } from "./SecondaryActionMenu.vue?vue&type=template&id=4b6556b2&scoped=true"
import script from "./SecondaryActionMenu.vue?vue&type=script&lang=js"
export * from "./SecondaryActionMenu.vue?vue&type=script&lang=js"

import "./SecondaryActionMenu.vue?vue&type=style&index=0&id=4b6556b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6556b2"]])

export default __exports__